<template><div><h1 id="artikelbewegungen" tabindex="-1"><a class="header-anchor" href="#artikelbewegungen"><span>Artikelbewegungen</span></a></h1>
<p>Artikelbewegungen — Deteillierte Liste der Artikelbewegungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Liste Artikelbewegungen zeigt pro [Partie], [Bewegungstyp] und [Datum] kumulierte Zugänge und Abgänge. Eingrenzung nach den Parametern [Lager], [Bewegungstyp], [Bewegungsdatum] sowie nach [Artikel] und [Artikelgruppe].</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Artikelbewegungen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Lager</dt>
<dd>Personen-ID des Lagers, mit Komma trennen; * = alle</dd>
<dt>Bewegungstyp</dt>
<dd>Bewegungstypen, mit Komma trennen; * = alle</dd>
<dt>Artikelnummer</dt>
<dd>Artikelnummer von ... bis ...</dd>
<dt>Artikelgruppe</dt>
<dd>Artikelgruppe von ...</dd>
<dt>bis</dt>
<dd>... bis Artikelgruppe, (alphanumerisch aufsteigend)</dd>
<dt>Exportformat</dt>
<dd>T = Textdatei, mit Leerzeichen formatierte Datei<br>E = Excel, mit Tabulator getrennte Felder in der Datei</dd>
<dt>Sortierung nach</dt>
<dd>Bewegungsdatum aufsteigend</dd>
<dt>Ausgabe</dt>
<dd>Drucker: A4-Portrait, formatierter Output<br>Textdatei: formatierter Output oder mit Tabulator getrennte Felder</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Bt</td>
<td>Bewegungstyp</td>
</tr>
<tr>
<td>Artikel</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Gr</td>
<td>Artikelgruppe</td>
</tr>
<tr>
<td>(P)M</td>
<td>Product Manager</td>
</tr>
<tr>
<td>ArtBez.</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>Lagerort</td>
<td>Lagerortnummer</td>
</tr>
<tr>
<td>Part</td>
<td>Partie im Lager</td>
</tr>
<tr>
<td>Bemerk.</td>
<td>Bemerkung aus der Artikelbewegung</td>
</tr>
<tr>
<td>Anzahl</td>
<td>Anzahl</td>
</tr>
<tr>
<td>Erf</td>
<td>Kurzzeichen des Erfassers</td>
</tr>
<tr>
<td>Datum</td>
<td>Datum</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                          29.05.2002 16:18:26 svw  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                              Artikelbewegungen</span>
<span class="line">  Beschreibung: Die Liste zeigt alle Artikelbewegungen in einem bestimmten</span>
<span class="line">  Zeitraum. Das Ergebnis zeigt Bewegungstyp, Artikel, Lager, Partie, Anzahl</span>
<span class="line">  Artikel, Bewegungsdatum.</span>
<span class="line">  Parameter: Datum von....: 01.01.2002 bis: 01.02.2002</span>
<span class="line">             Lagernummer..: \*</span>
<span class="line">             Bewegungstyp.: W</span>
<span class="line">             Art.nummer...:            bis:</span>
<span class="line">             Art.gruppen..:            bis:</span>
<span class="line">             Export Format: T</span>
<span class="line"></span>
<span class="line">             Sortierung...: Bewegungsdatum aufsteigend</span>
<span class="line"></span>
<span class="line"></span>
<span class="line"></span>
<span class="line">Bt Artikel Gr    (P)M ArtBez.  Lagerort Part Bemerk.   Anzahl Erf Datum</span>
<span class="line">-- ------- ----- ---- -------- -------- ---- -------- ------- --- --------</span>
<span class="line">W  K139    840        Serviett 96963350 V 1                -1 svw 07.01.02</span>
<span class="line">W  K139    840        Serviett 96963350 V 1                -2 svw 09.01.02</span>
<span class="line">W  K139    840        Serviett 96963350 V 1                -1 svw 10.01.02</span>
<span class="line">W  K139    840        Serviett 96963350 V 1                -1 svw 10.01.02</span>
<span class="line">W  K139    840        Serviett 96963350 V 1               -10 svw 11.01.02</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Der Lagerbestand von Artikel K139 wurde am 07.01. um 1 Stück verringert durch Abgang aus Warenverkauf.</p>
</div></template>


